<template>
	<layer class="opt_more_g" name="listNum">
		<div class="box_opt_menu list_num_type">
			<div class="menu_item" v-for="listNum in listNums">
				<a href="javascript:" class="link_menu" @click="callback(listNum)">{{ listNum }}개</a>
			</div>
		</div>
	</layer>
</template>

<script>
import Layer from './Layer.vue';

export default {
	components: {Layer},
	props: {
		listNums: {
			type: Array,
			default: () => ([])
		},
		callback: {
			type: Function,
			default: () => null
		}
	}
}
</script>
